module.exports = __webpack_public_path__ + "static/home-jumbotron-534958a2cee3bb524a0bae118f2a4219.jpg";